require('./bootstrap');


import { createApp } from 'vue';
import axios from './axios';
import MomentPlugin from './utils/moment';

// Import your Vue components
import BusinessList from './components/BusinessList.vue';
import FeaturedBusinessList from './components/FeaturedBusinessList.vue';
import AllBusinessList from './components/AllBusinessList.vue';
import GothBusinessList from './components/GothBusinessList.vue';

// Create and mount Vue app
const app = createApp({});
app.config.globalProperties.$axios = axios;

app.use(MomentPlugin, {
    invalidText: '--', // Default text for invalid dates
    formats: {
        // You can override default formats here
        date: 'YYYY-MM-DD',
        datetime: 'YYYY-MM-DD HH:mm:ss',
        displayDate: 'DD MMM YYYY',
        displayDateTime: 'DD MMM YYYY, hh:mm A',
        businessDate: 'MMM DD, YYYY',
        iso: 'YYYY-MM-DDTHH:mm:ssZ'
    }
});

// Register global component
app.component('business-list', BusinessList);
app.component('featured-business-list', FeaturedBusinessList);
app.component('all-business-list', AllBusinessList);
app.component('goth-business-list', GothBusinessList);

// Mount to a specific element
app.mount('#app');

export { axios };
